import config from './config'
import { handleResponse } from './handle-response'
import { checkToken, authHeader } from './helpers'

export const stripeService = {
	createSession,
	getPortalSession
}

async function createSession(body) {
	await checkToken();

	const headers = {
		'Content-Type': 'application/json',
		...authHeader(),
	};

	const requestOptions = { method: 'POST', headers, body };
	return fetch(`${config.apiUrl}/stripe/session/`, requestOptions)
		.then(handleResponse)
		.then(data => data);
}

async function getPortalSession() {
	await checkToken()
	const requestOptions = { method: 'GET', headers: authHeader() }
	return fetch(`${config.apiUrl}/stripe/customer/portal/`, requestOptions)
		.then(handleResponse)
		.then(data => data)
}